import React from 'react';
import Auth from '../../../Helpers/auth';
import { NavLink, Link } from 'react-router-dom';
import CompanyCheck from './CompanyDashboardCheck.component';

const BottomNav = () => {
  return (
    <div className="bottomNav">
      <nav className="links">
        <NavLink to="/">Home</NavLink>
        <div className="dropdown">
          <NavLink to="/online" className="dropbtn">
            Training
          </NavLink>
          <div className="dropdown-content boxShadow">
            <Link to="/online">Online</Link>
            <Link to="/classroom">Classroom</Link>
          </div>
        </div>
        <NavLink to="/contact-us" className="dropbtn">
          Contact Us
        </NavLink>
        <NavLink to="/resources">Resources</NavLink>
        {Auth.loggedIn() && (
          <>
            <CompanyCheck />
          </>
        )}
      </nav>
    </div>
  );
};

export default BottomNav;
